// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-pages-menu {
    /* height: 100vh; 
    background: var(--white-color);*/      
    margin-top: -24px;

    padding: 16px;
    height: 130vh;
    width: calc(calc(calc(100% /12) * 3) - var(--space-and-half) );
    /* position: absolute; */
    background: var(--white-color);
    position: fixed;
}

.home-pages-menu__content {
    background: var(--white-color);
    height: 104vh;
    margin-top: 24px;
    margin-bottom: 35px;
}
.home-pages-menu__title .baloa-headline-2 {
    color: var(--primary-very-dark-color);
}

.home-pages-menu__content__field {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    margin-top: 12px;
    color: var(--primary-dark-color);
}

.home-pages-menu__content__field_create {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    margin-top: 12px;
    color: var(--new-green-color);
    background: #EAF7F0;
    border: 1px solid var(--new-green-color);
}

.home-pages-menu__content__field:hover, .home-pages-menu__content__field:hover .home-pages-menu__content__field__data__text.baloa-normal-medium {
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.home-pages-menu__content__field.active, .home-pages-menu__content__field.active .home-pages-menu__content__field__data__text.baloa-normal-medium {
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.home-pages-menu__content__field__icon {
    margin-right: 10px;
    font-size: 24px;
    align-items: center;
    display: flex;
}

.home-pages-menu__content__field__icon-create {
    margin-right: 4px;
    font-size: 24px;
    align-items: center;
    display: flex;
}

.home-pages-menu__content__field__data {
    padding-left: 10px;
    display: flex;
    max-height: var(--space-x3);
    min-height: var(--space-x3);
    align-items: center;
}

.home-pages-menu__content__field__data-create {    
    display: flex;
    max-height: var(--space-x3);
    min-height: var(--space-x3);
    align-items: center;
    margin: 0 auto;
}

.home-pages-menu__content__field__data__text.baloa-normal-medium{
    color: var(--primary-dark-color);
}

.home-pages-menu__content__field__data__text_create.baloa-normal-medium{
    color: var(--new-green-color);
}

.home-pages-menu__content__field__icon-chevron {
    font-size: var(--space-and-half);
}
.home-pages-menu__content__button {    
    margin-top: var(--space-x2);
    cursor: pointer;
    width: 30%;
}

.home-pages-menu__content__button__text{
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: 12px !important;
    line-height: var(--space-and-half) !important;
    letter-spacing: 0.04em !important;
    color: var(--primary-very-dark-color) !important;
}

.home-pages-menu__settings {
    grid-column-start: 7;
    grid-column-end: 11;
}

/* @media screen and (min-width: 1200px) and (max-width: 1760px) {
    .home-pages-menu__content__field {
        width: calc( var( --space-x3 ) * 6 );
    }
} */

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .home-pages-menu__mobile-menu__container {
        background-color: var(--white-color);
    }
    .home-pages-menu__mobile-menu__container .baloa-subtitle-2 {
/*         font-size: calc( var(--space) + var(--space-half) );
        line-height: calc( var(--space-x2) - var(--space-quarter) ); */
        color: var(--new-text-link-color);
        padding: 12px;
        border-top: 2px solid var(--new-background-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .home-pages-menu__mobile-menu__actions {
        display: flex;
        justify-content: space-between;
        border-top: 2px solid var(--new-background-color);
        border-bottom: 1px solid var(--new-background-color);
        padding: 12px;
    }
    .home-pages-menu__mobile-menu__actions .baloa-table-column {
        color: var(--primary-dark-color);
        padding: 8px 12px;
        display: flex;
        align-items: center;
        width: 48%;
        font-size: 15px;
        line-height: normal;
    }
    .home-pages-menu__mobile-menu__actions .baloa-table-column.active {
        background-color: #EAF7F0;
        border-radius: 25px;
        color: var(--new-green-color);
    }

    .home-pages-menu__mobile-menu__new-button {
        padding: 8px;
        line-height: unset;
    }

    .home-pages-menu__mobile-menu__new-button .icon {
        grid-area: icon;
        margin-right: 2px;
        font-weight: var(--font-medium);
        font-size: 17px;
    }

    .home-pages-menu__content__field__icon {
        margin-right: 4px;
        font-size: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/home-pages-menu/HomePagesMenuComponent.styles.css"],"names":[],"mappings":"AAAA;IACI;oCACgC;IAChC,iBAAiB;;IAEjB,aAAa;IACb,aAAa;IACb,8DAA8D;IAC9D,wBAAwB;IACxB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,2BAA2B;IAC3B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,wCAAwC;IACxC,0BAA0B;IAC1B,6CAA6C;IAC7C,iCAAiC;IACjC,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;;;GAIG;;AAEH,yCAAyC,4BAA4B;IACjE;QACI,oCAAoC;IACxC;IACA;AACJ;sEACsE;QAC9D,iCAAiC;QACjC,aAAa;QACb,iDAAiD;QACjD,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,iDAAiD;QACjD,oDAAoD;QACpD,aAAa;IACjB;IACA;QACI,gCAAgC;QAChC,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,UAAU;QACV,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,+BAA+B;QAC/B,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":[".home-pages-menu {\n    /* height: 100vh; \n    background: var(--white-color);*/      \n    margin-top: -24px;\n\n    padding: 16px;\n    height: 130vh;\n    width: calc(calc(calc(100% /12) * 3) - var(--space-and-half) );\n    /* position: absolute; */\n    background: var(--white-color);\n    position: fixed;\n}\n\n.home-pages-menu__content {\n    background: var(--white-color);\n    height: 104vh;\n    margin-top: 24px;\n    margin-bottom: 35px;\n}\n.home-pages-menu__title .baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.home-pages-menu__content__field {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-radius: 4px;\n    margin-top: 12px;\n    color: var(--primary-dark-color);\n}\n\n.home-pages-menu__content__field_create {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-radius: 4px;\n    margin-top: 12px;\n    color: var(--new-green-color);\n    background: #EAF7F0;\n    border: 1px solid var(--new-green-color);\n}\n\n.home-pages-menu__content__field:hover, .home-pages-menu__content__field:hover .home-pages-menu__content__field__data__text.baloa-normal-medium {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.home-pages-menu__content__field.active, .home-pages-menu__content__field.active .home-pages-menu__content__field__data__text.baloa-normal-medium {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.home-pages-menu__content__field__icon {\n    margin-right: 10px;\n    font-size: 24px;\n    align-items: center;\n    display: flex;\n}\n\n.home-pages-menu__content__field__icon-create {\n    margin-right: 4px;\n    font-size: 24px;\n    align-items: center;\n    display: flex;\n}\n\n.home-pages-menu__content__field__data {\n    padding-left: 10px;\n    display: flex;\n    max-height: var(--space-x3);\n    min-height: var(--space-x3);\n    align-items: center;\n}\n\n.home-pages-menu__content__field__data-create {    \n    display: flex;\n    max-height: var(--space-x3);\n    min-height: var(--space-x3);\n    align-items: center;\n    margin: 0 auto;\n}\n\n.home-pages-menu__content__field__data__text.baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n\n.home-pages-menu__content__field__data__text_create.baloa-normal-medium{\n    color: var(--new-green-color);\n}\n\n.home-pages-menu__content__field__icon-chevron {\n    font-size: var(--space-and-half);\n}\n.home-pages-menu__content__button {    \n    margin-top: var(--space-x2);\n    cursor: pointer;\n    width: 30%;\n}\n\n.home-pages-menu__content__button__text{\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: 12px !important;\n    line-height: var(--space-and-half) !important;\n    letter-spacing: 0.04em !important;\n    color: var(--primary-very-dark-color) !important;\n}\n\n.home-pages-menu__settings {\n    grid-column-start: 7;\n    grid-column-end: 11;\n}\n\n/* @media screen and (min-width: 1200px) and (max-width: 1760px) {\n    .home-pages-menu__content__field {\n        width: calc( var( --space-x3 ) * 6 );\n    }\n} */\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .home-pages-menu__mobile-menu__container {\n        background-color: var(--white-color);\n    }\n    .home-pages-menu__mobile-menu__container .baloa-subtitle-2 {\n/*         font-size: calc( var(--space) + var(--space-half) );\n        line-height: calc( var(--space-x2) - var(--space-quarter) ); */\n        color: var(--new-text-link-color);\n        padding: 12px;\n        border-top: 2px solid var(--new-background-color);\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .home-pages-menu__mobile-menu__actions {\n        display: flex;\n        justify-content: space-between;\n        border-top: 2px solid var(--new-background-color);\n        border-bottom: 1px solid var(--new-background-color);\n        padding: 12px;\n    }\n    .home-pages-menu__mobile-menu__actions .baloa-table-column {\n        color: var(--primary-dark-color);\n        padding: 8px 12px;\n        display: flex;\n        align-items: center;\n        width: 48%;\n        font-size: 15px;\n        line-height: normal;\n    }\n    .home-pages-menu__mobile-menu__actions .baloa-table-column.active {\n        background-color: #EAF7F0;\n        border-radius: 25px;\n        color: var(--new-green-color);\n    }\n\n    .home-pages-menu__mobile-menu__new-button {\n        padding: 8px;\n        line-height: unset;\n    }\n\n    .home-pages-menu__mobile-menu__new-button .icon {\n        grid-area: icon;\n        margin-right: 2px;\n        font-weight: var(--font-medium);\n        font-size: 17px;\n    }\n\n    .home-pages-menu__content__field__icon {\n        margin-right: 4px;\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
